// extracted by mini-css-extract-plugin
export default {"mainWrapper":"enquiry-edit_mainWrapper__Xj3g2","header":"enquiry-edit_header__Xfi1K","quoteHeading":"enquiry-edit_quoteHeading__J3Neh","closeIcon":"enquiry-edit_closeIcon__J+gkL"};